var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { pipe } from 'fp-ts/function';
import * as t from 'io-ts';
import * as E from 'fp-ts/Either';
var StringMaxLengthType = /** @class */ (function (_super) {
    __extends(StringMaxLengthType, _super);
    function StringMaxLengthType(name, is, validate, encode, max) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.max = max;
        _this._tag = 'StringMaxLengthType';
        return _this;
    }
    return StringMaxLengthType;
}(t.Type));
export { StringMaxLengthType };
export function stringMaxLength(max) {
    return new StringMaxLengthType("StringMaxLength<".concat(max, ">"), function (u) { return t.string.is(u) && u.length <= max; }, function (u, c) {
        return pipe(t.string.validate(u, c), E.chain(function (u) { return (u.length <= max ? t.success(u) : t.failure(u, c)); }));
    }, t.identity, max);
}
